<div class="row">
    <div class="coil-analytics col text-secondary">
    <small>Coil analytics</small>
  </div>
</div>
<div class="row mb-3">
    <div class="coil-number col text-nowrap fs-5"><b>Coil {{ coil.coilSheetId}}</b>
        <mat-icon class="info" matTooltip="Coil insights are visualized along the coil with different levels of accuracy based on data availability per product type & specification"
        aria-label="Button that displays a tooltip when focused or hovered over" matTooltipClass="mat-info">info_outline</mat-icon></div>
    @if(!showInsufficientDisclaimer) {
        <div class="col d-flex gap-2 justify-content-end">
            <!-- <button class="export btn btn-sm btn-primary btn-panel d-flex align-items-center" (click)="showDialogDefect()"><i class="material-icons-outlined">error_outline</i>&nbsp;&nbsp;Defect</button> -->
    <app-defect-dialog 
  [showDefectDialog]="showDefectDialog" 
  (displayChangedefect)="onDialogDefectClose($event)">
</app-defect-dialog>
            <app-dropdown-button class="selected-graph" [defaultSelection]="selectedGraph.label" [dropList]="availableGraphs" (selectElement)="onSelectGraphEvent($event)"></app-dropdown-button>
            <button class="export btn btn-sm btn-primary btn-panel d-flex align-items-center" (click)="showDialog()"><i class="material-icons-outlined">file_download</i>&nbsp;&nbsp;Export</button>
            <app-export-dialog 
                [showExportDialog]="showExportDialog" 
                (displayChange)="onDialogClose($event)">
            </app-export-dialog>
        </div>
    }
</div>
@if(showMediumDisclaimer && !showInsufficientDisclaimer) {
    <div class="disclaimer">
        <mat-icon class="disclaimer-info-medium">error_outline</mat-icon> <span class="disclaimer-text">Mapping of measurements uncertain for length position</span> 
    </div>
 }
@if(!showInsufficientDisclaimer) {
    <div class="row">
        <div class="col">
            <div id="chart1">
                @if(chartOptions1) {
                    <apx-chart
                        [series]="chartOneSeries"
                        [chart]="chartOptions1.chart"
                        [xaxis]="chartOptions1.xaxis"
                        [yaxis]="chartOptions1.yaxis"
                        [colors]="chartOptions1.colors"
                        [fill]="chartOptions1.fill"
                        [markers]="chartOptions1.markers"
                        [stroke]="chartOptions1.stroke"
                        [responsive]="chartOptions1.responsive"
                        [legend]="chartOptions1.legend"
                        [annotations]="chartOptions1.annotations"
                    ></apx-chart>
                }
            </div>
            
            <div id="chart2">
                @if(chartOptions2) {
                    <apx-chart
                        [series]="cahrttwoSeries"
                        [chart]="chartOptions2.chart"
                        [xaxis]="chartOptions2.xaxis"
                        [colors]="chartOptions1.colors"
                        [fill]="chartOptions2.fill"
                        [yaxis]="chartOptions2.yaxis"
                    ></apx-chart>
                }
            </div>
        </div> 
    </div>
}


@if(graphType === 'WIDTH_GRAPH' && !showInsufficientDisclaimer) {
<div class="row">
    <div class="col text-center">
        <span class="material-symbols-outlined insufficient-square">crop_square</span> 
        <span class="text-secondry text-sm text-black-50" style="font-size: small;">Insufficient data quality</span>&nbsp;&nbsp;&nbsp;
        <span class="material-symbols-outlined medium-square">crop_square</span> 
        <span class="text-secondry text-sm text-black-50" style="font-size: small;">Medium data quality</span>&nbsp;&nbsp;&nbsp;
        <span class="coil-label">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span class="text-secondry text-sm text-black-50" style="font-size: small;">Coil {{selectedGraph.label}}</span>&nbsp;&nbsp;&nbsp;
        <span class="tolerance-label-upper">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span class="text-secondry text-sm text-black-50" style="font-size: small;">Upper Limit</span>&nbsp;&nbsp;&nbsp;
        <span class="tolerance-label-lower">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span class="text-secondry text-sm text-black-50" style="font-size: small;">Lower Limit</span>
    </div>
</div>
}

@if(graphType === 'THICKNESS_GRAPH' && !showInsufficientDisclaimer) {
<div class="row">
    <div class="col text-center">
        <span class="material-symbols-outlined insufficient-square">crop_square</span> 
        <span class="text-secondry text-sm text-black-50" style="font-size: small;">Insufficient data quality</span>&nbsp;&nbsp;&nbsp;
        <span class="material-symbols-outlined medium-square">crop_square</span> 
        <span class="text-secondry text-sm text-black-50" style="font-size: small;">Medium data quality</span>&nbsp;&nbsp;&nbsp;
        <span class="coil-label">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span class="text-secondry text-sm text-black-50" style="font-size: small;">Coil {{selectedGraph.label}}</span>&nbsp;&nbsp;&nbsp;
        <span class="tolerance-label-upper">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span class="text-secondry text-sm text-black-50" style="font-size: small;">Upper Limit</span>&nbsp;&nbsp;&nbsp;
        <span class="tolerance-label-lower">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span class="text-secondry text-sm text-black-50" style="font-size: small;">Lower Limit</span>
    </div>
</div>
}

@if(graphType === 'CROWN_GRAPH' && !showInsufficientDisclaimer) {
<div class="row">
    <div class="col text-center">
        <span class="material-symbols-outlined insufficient-square">crop_square</span> 
        <span class="text-secondry text-sm text-black-50" style="font-size: small;">Insufficient data quality</span>&nbsp;&nbsp;&nbsp;
        <span class="material-symbols-outlined medium-square">crop_square</span> 
        <span class="text-secondry text-sm text-black-50" style="font-size: small;">Medium data quality</span>&nbsp;&nbsp;&nbsp;
        <span class="coil-label">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span class="text-secondry text-sm text-black-50" style="font-size: small;">Crown</span>&nbsp;&nbsp;&nbsp;
    </div>
</div>
}

@if(graphType === 'WEDGE_GRAPH' && !showInsufficientDisclaimer) {
    <div class="row">
        <div class="col text-center">
            <span class="material-symbols-outlined insufficient-square">crop_square</span> 
            <span class="text-secondry text-sm text-black-50" style="font-size: small;">Insufficient data quality</span>&nbsp;&nbsp;&nbsp;
            <span class="material-symbols-outlined medium-square">crop_square</span> 
            <span class="text-secondry text-sm text-black-50" style="font-size: small;">Medium data quality</span>&nbsp;&nbsp;&nbsp;
            <span class="coil-label">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="text-secondry text-sm text-black-50" style="font-size: small;">Wedge</span>
        </div>
    </div>
    }

@if(showInsufficientDisclaimer) {
    <div class="disclaimer">
        <mat-icon class="disclaimer-info-insufficient">error_outline</mat-icon> <span class="disclaimer-text">Mapping of measurements too uncertain for length position</span> 
    </div>
    <div class="insufficient-empty-content-img"></div>
 }
